/**
 * Rounded health label with a colour dot. The text carries the meaning; colour is
 * reinforcement only. Same look as the reliability view's pill, using the global tokens.
 */
import type { StatusTone } from '../../site';

interface SiteMapStatusPillProps {
  readonly tone: StatusTone;
  readonly label: string;
}

export function SiteMapStatusPill({ tone, label }: SiteMapStatusPillProps): JSX.Element {
  return (
    <span className={`site-map-pill site-map-pill--${tone}`}>
      <span className="site-map-pill__dot" aria-hidden="true" />
      {label}
    </span>
  );
}
